import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { MatchNoteCreateDTO, MatchNotePagedResultVO, MatchNoteVO } from '../types';

export const matchNoteApi = {
  getList: async (params: {
    projectCode: string;
    keyNodeId?: number;
  }): Promise<MatchNoteVO[]> => {
    const queryParams = new URLSearchParams();
    queryParams.append('projectCode', params.projectCode);
    if (params?.keyNodeId) queryParams.append('keyNodeId', String(params.keyNodeId));

    const response = await fetch(`${API_ENDPOINTS.MATCH_NOTE.LIST}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    const result = await handleResponse<MatchNotePagedResultVO>(response);
    return (result.list ?? []).map(normalizeMatchNote);
  },

  create: async (data: MatchNoteCreateDTO): Promise<MatchNoteVO> => {
    const response = await fetch(API_ENDPOINTS.MATCH_NOTE.CREATE, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    const note = await handleResponse<MatchNoteVO>(response);
    return normalizeMatchNote(note);
  },

  delete: async (id: number): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.MATCH_NOTE.DELETE(id), {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    await handleResponse<unknown>(response);
    return true;
  },
};
